module.exports = __webpack_public_path__ + "static/media/52573998_2452982388110271_9203069936899981312_o.cea38a81.jpg";